export enum EventTrackerCategories {
  LOGIN = 'log-in',
  CUSTOMER_SETTINGS = 'customer-settings',
  AUTOMATED_TRANSFERS_NOTIFICATION_CENTER = 'automated-transfers-notification-center',
  AUTOMATED_TRANSFERS_NAVIGATION = 'automated-transfers-navigation',
  ITEMS_ON_THE_ROAD = 'items-on-the-road',
  SCHEDULED_TRANSFERS = 'scheduled-transfers',
}

export enum EventTrackerActions {
  CUSTOMER_SETTINGS_AUTOMATED_TRANSFERS_TAB_OPEN = 'customer-settings-automated-transfers-tab-open',
  CUSTOMER_SETTINGS_AUTOMATED_TRANSFERS_CONFIG_SAVE = 'customer-settings-automated-transfers-config-save',
  CUSTOMER_SETTINGS_AUTOMATED_TRANSFERS_NOTIFICATIONS_TAB_OPEN = 'customer-settings-automated-transfers-notifications-tab-open',
  CUSTOMER_SETTINGS_AUTOMATED_TRANSFERS_NOTIFICATION_TYPE_ENABLE = 'customer-settings-automated-transfers-notification-type-enable',
  CUSTOMER_SETTINGS_AUTOMATED_TRANSFERS_NOTIFICATION_TYPE_DISABLE = 'customer-settings-automated-transfers-notification-type-disable',
  CUSTOMER_SETTINGS_AUTOMATED_TRANSFERS_NOTIFICATIONS_SAVE = 'customer-settings-automated-transfers-notifications-save',
  AUTOMATED_TRANSFERS_NOTIFICATION_ACKNOWLEDGE = 'automated-transfers-notification-acknowledge',
  AUTOMATED_TRANSFERS_NOTIFICATION_ACKNOWLEDGE_ALL = 'automated-transfers-notification-acknowledge-all',
  AUTOMATED_TRANSFERS_NOTIFICATION_CENTER_OPEN = 'automated-transfers-notification-center-open',
  AUTOMATED_TRANSFERS_ITEMS_ON_THE_ROAD_NAVIGATION_OPEN = 'automated-transfers-items-on-the-road-navigation-open',
  AUTOMATED_TRANSFERS_SCHEDULED_TRANSFERS_NAVIGATION_OPEN = 'automated-transfers-scheduled-transfers-navigation-open',
  ITEMS_ON_THE_ROAD_PAUSE = 'items-on-the-road-pause',
  ITEMS_ON_THE_ROAD_RESUME = 'items-on-the-road-resume',
  ITEMS_ON_THE_ROAD_CANCEL = 'items-on-the-road-cancel',
  ITEMS_ON_THE_ROAD_FORCE_TRANSFER = 'items-on-the-road-force-transfer',
  SCHEDULED_TRANSFERS_CANCEL = 'scheduled-transfers-cancel',
  SCHEDULED_TRANSFERS_DEACTIVATE = 'scheduled-transfers-deactivate',
  SCHEDULED_TRANSFERS_ACTIVATE = 'scheduled-transfers-activate',
}

export enum ExecType {
  TRACK_EVENT = 'trackEvent',
}
